import angular from 'angular';
import { ResourceStringsModule } from '@buildium/angularjs-core/dist/components/resource-strings';
import {ResourceStringsLoaderService} from './resource-strings-loader-service';
import {ManagerApiModule} from '../api/manager-api.module';
import {ManagerSettingsModule} from '../settings/settings.module';

export const ManagerResourceStringsModule = angular.module('buildium.manager.resource-strings', [
    ResourceStringsModule.name,
    ManagerApiModule.name,
    ManagerSettingsModule.name
])
    .service('ResourceStringsLoaderService', ResourceStringsLoaderService);
